import { Component } from "react";
import Card from "@/components/card";
import Title from "@/components/title";
import CourseInfo from "@/components/courseInfo";
import folder from "@/images/folder-open.svg";
import school from "@/images/school.svg";
import pin from "@/images/pin.svg";
import profile from "@/images/profile.svg";
import DegreeLevel from "@/services/degreeLevel";
import LinkButton from "@/components/linkButton";

class ResultCard extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      degreeLevel: 0
    }
    this.componentDidMount = this.componentDidMount.bind(this);
  }

  componentDidMount() {
    let degreeLevel = new DegreeLevel();
    degreeLevel.getCourseLevel(this.props.course).then((degreeLevel) => {
      this.setState({degreeLevel: degreeLevel})
    }).catch((error) => console.log(error));
    
  }

  render() { 
    let title = <>
      <span className="text-base font-t-regular normal-case text-khaki-default">{this.props.course.Type_de_diplome}</span><br/> 
      <span className="font-t-regular normal-case">{this.props.course.Domaine_du_MESRI_1}</span><br/>
      <span className="">{this.props.course.Parcours_Specialites_ED}</span>
    </>;
    return ( <div className="grid h-full" key={this.props.course.AzureSearch_DocumentKey}>
      <Card 
        width="1"
        height="2"
        justify="start"
        background="white"
        border="khaki-default"
        textColor="gray-darkest"
      >
        <Title
          title={title}
          subtitle=""
          variant="3"
          justify="center"
        />
        <CourseInfo label="Domaine de formation : ">
          <img src={folder} alt="" className="h-4 w-4" />
          <span>{this.props.course.Domaine_du_MESRI}</span>
        </CourseInfo>
        {this.props.course.Domaine_Professionnel.length > 0 &&
          <CourseInfo label="Domaine professionnel : ">
            <img src={profile} alt="" className="h-4 w-4" />
            <p>{this.props.course.Domaine_Professionnel.map((field) => <>{field}<br/></>)}</p>
          </CourseInfo>
        }
        <CourseInfo label="Niveau de diplôme :">
          <img src={school} alt="" className="h-4 w-4" />
          <span>{this.state.degreeLevel}</span>
        </CourseInfo>
        <CourseInfo label="Site principal : ">
          <img src={pin} alt="" className="h-4 w-4" />
          <p>
            {this.props.course.Site_principal && (<>{this.props.course.Site_principal}<br/></>)}
            {this.props.course.UFR_site_principal && (<>{this.props.course.UFR_site_principal}<br/></>)}
            {this.props.course.adresse_site_principal && (<>{this.props.course.adresse_site_principal}<br/></>)}
            {this.props.course.Code_postal_site_principal} {this.props.course.Commune_site_principal}
          </p>
        </CourseInfo>
        {!!this.props.course.Site_n_3.length &&
          <CourseInfo label="Sites secondaires :">
            <img src={pin} alt="" className="h-4 w-4" />
            <ul>
              {this.props.course.Site_n_3.map((location, index) => (
                <li key={index}>{location}</li>
              ))}
            </ul>
          </CourseInfo>
        }
        <div className="mt-4 flex-grow flex items-end">
          <LinkButton 
            label="En savoir +"
            padding="2"
            classes="text-xs"
            href={this.props.course.Lien_FF__Site_dedie}
            target="_blank"
          />
        </div>
      </Card>
    </div> );
  }
}
 
export default ResultCard;